export const CHART_ACTIVITY_HEIGHT = 95
export const CHART_TRANSACTIONS_HEIGHT = 270
